module.exports = __webpack_public_path__ + "static/media/autre-al.9dce9bc8.jpg";